import { candidateKey, formatCandidateTime } from './einvoice-manual-candidates'
import type { ManualCandidate } from '@/lib/api/einvoice-api'
import { Button } from '@/components/ui/button'
import { useManualCandidates } from '@/hooks/use-einvoice-manual-candidates'
import { formatVND } from '@/lib/format'
import { m } from '@/lib/paraglide/messages'

/** Read-only list shown while confirming "Phát hành lại": invoices made on
 *  MISA's website that may already be this order's. Nothing is shown when
 *  there is none; one line when MISA could not be asked. */
export function EInvoiceRepublishCandidates({
    orderId,
    onUseCandidate,
}: {
    orderId: string
    onUseCandidate?: (candidate: ManualCandidate) => void
}) {
    const { candidates, status } = useManualCandidates(orderId)
    if (status === 'unavailable')
        return (
            <p className="text-sm text-muted-foreground">
                {m.einvoice_candidates_unavailable()}
            </p>
        )
    if (candidates.length === 0) return null
    return (
        <section className="space-y-1" aria-label="manual-candidates">
            <p className="text-sm font-medium">
                {m.einvoice_republish_candidates_title()}
            </p>
            <ul className="space-y-1">
                {candidates.map((c) => (
                    <li
                        key={candidateKey(c)}
                        className="flex flex-wrap items-center justify-between gap-2 rounded-md border px-3 py-2 text-sm"
                    >
                        <span className="tabular-nums">
                            {m.einvoice_candidate_row({
                                number: c.inv_no,
                                amount: formatVND(c.total_amount),
                                time: formatCandidateTime(c.created_at),
                            })}
                        </span>
                        {onUseCandidate ? (
                            <Button
                                type="button"
                                variant="link"
                                size="sm"
                                className="h-auto p-0"
                                onClick={() => onUseCandidate(c)}
                            >
                                {m.einvoice_republish_candidate_this()}
                            </Button>
                        ) : null}
                    </li>
                ))}
            </ul>
        </section>
    )
}
